/**
 * 台灣營利事業統一編號（8 碼）檢查碼驗證（財政部公式）。
 * 僅能驗證格式與檢查碼，無法證明該統編於商業登記中存在。
 */
export function isValidTaiwanGuiNumber(input: string): boolean {
  const s = String(input || '').replace(/\D/g, '');
  if (s.length !== 8) return false;

  const weights = [1, 2, 1, 2, 1, 2, 4, 1];
  let sum = 0;
  for (let i = 0; i < 8; i++) {
    const d = parseInt(s[i], 10);
    if (Number.isNaN(d)) return false;
    const p = d * weights[i];
    sum += Math.floor(p / 10) + (p % 10);
  }

  if (sum % 10 === 0) return true;
  if (s[6] === '7' && (sum + 1) % 10 === 0) return true;
  return false;
}

export const TAIWAN_GUI_NUMBER_HINT =
  '須為 8 位數字且通過統一編號檢查碼（僅防誤填，不代表商業登記真實性）';

/** 註冊／auth upsert 寫入的統編佔位值，表單應視為未填 */
export function isPlaceholderCompanyTaxId(taxId: string | null | undefined): boolean {
  const s = String(taxId ?? '').trim();
  if (!s) return false;
  if (s === 'TEMP_TAX_ID') return true;
  return /^PENDING-/i.test(s);
}

export function normalizeCompanyTaxIdForDisplay(taxId: string | null | undefined): string {
  if (!taxId || isPlaceholderCompanyTaxId(taxId)) return '';
  return String(taxId).replace(/\D/g, '').slice(0, 8);
}

/** 儲存至 DB：空白或佔位 → null；否則 8 碼數字 */
export function normalizeCompanyTaxIdForSave(taxId: string | null | undefined): string | null {
  if (isPlaceholderCompanyTaxId(taxId)) return null;
  const digits = String(taxId ?? '').replace(/\D/g, '');
  if (!digits) return null;
  return digits.slice(0, 8);
}

export function normalizeOptionalCompanyTextField(value: string | null | undefined): string | null {
  const trimmed = String(value ?? '').trim();
  return trimmed ? trimmed : null;
}

/** 商工公示查詢（對照公司名稱／統編） */
export const FIND_BIZ_NAT_GOV_URL = 'https://findbiz.nat.gov.tw/';

/** 財政部稅務入口網（稅籍相關） */
export const MOF_ETAX_PORTAL_URL = 'https://www.etax.nat.gov.tw/';
